/**
 * Shared Event helpers and handlers for ALL layer types
 */

module.exports = {

  _eventsUnRegistry: null,

  /**
   * @param  {String} eventname
   * @param  {Function} handler
   * @param  {Object} context
   * @param  {Object} target A LeafletLayer or DOM element
   * @returns {Function} A remove method
   */
  on: function (eventname, handler, context, target) {
    target = target || this.leafletLayer;
    // make sure this event is only registered once
    target.removeEventListener(eventname, handler);
    target.addEventListener(eventname, handler, context);

    var removeEventListener = function () {
      target.removeEventListener(eventname, handler, this);
    }.bind(context);

    this._eventsUnRegistry = this._eventsUnRegistry || this._newUnregisterEventsRegistry();
    this._eventsUnRegistry.add(removeEventListener);

    return removeEventListener;
  },

  once: function (eventname, handler, context, target) {
    target = target || this.leafletLayer;
    target.once(eventname, handler, context);
  },

  /**
   * Removes all registered layer event listeners.
   * @returns {void}
   */
  _removeEventListeners: function () {
    if (this._eventsUnRegistry) {
      this._eventsUnRegistry.run();
    }
  },

  /**
   * Registers all shared event listeners
   * @returns {void}
   */
  _registerEventListeners: function () {
    this.once('add', this.onAdd, this);
    this.on('click', this.onLayerClicked, this);
    this.on('dragstart', this.onLayerDragStart, this);
    this.on('dragend', this.onLayerDragEnd, this);
    this.on('remove', this.onLayerRemove, this);
    this.on('mousedown', this.onLayerMousedown, this);
  },

  //////////////////////////////////////////////////////////////////////////////
  // Shared Event Handlers
  //////////////////////////////////////////////////////////////////////////////

  onAdd: function () {
    this.map = this.leafletLayer._map;
    this.toggleEditable();
  },

  onLayerMousedown: function (e) {
    var map = this.map;
    if (!this.isActive) {
      // hack...
      //
      // this works when the path has not been specifically targeted via a "click" event, i.e.
      // user is over a path layer and immediately begins to drag (signaling desire to move the
      // map rather than the path).
      //
      // @note we will probably need to do something similar on a "touchstart"
      map.dragging._draggable._onDown(e.originalEvent);
      map.dragging.enable();
    }
  },

  onLayerClicked: function (e) {
    var latlng = e.latlng;

    if (!this.isClickable()) {
      return;
    }

    if (!this.isActive) {
      this.popupClosedByUser = false; // reset the flag
      // change the active layer to this one. The event data is passed so it can
      // be made available to whatever needs it, like positioning the popup. This
      // action will enable editing and show the dialog
      if (latlng) {
        this.setPopupLatLng(latlng);
        this.Actions.SetActiveLayer.dispatch(this.layer);
      }
    } else if (this.isPopupOpen) {
      // if already open we are just moving it
      if (latlng) {
        this.movePopup(latlng);
      }
    } else if (!this.isPopupOpen) {
      this.popupClosedByUser = false; // reset the flag

      // if not open we need to re-initialize the content because when the content
      // is removed from the DOM by leaflet we lose the `ng-click` bindings
      if (latlng) {
        this.setPopupLatLng(latlng);
      }
      this.Actions.OpenActiveLayerPopup.dispatch();
    }
  },

  onLayerDragStart: function () {
    var map = this.map;
    if (this.isActive) {
      // temporary hide the popup for the active layer
      this.hidePopup();
      if (map.dragging.enabled()) {
        map.dragging.disable();
      }
    }
  },

  onLayerDragEnd: function (e) {
    var map = this.map;
    // dragend fires on click so we filter out false positives
    if (e.distance > 0) {
      this._dragged = true;
      this.setPopupLatLng(null);
      this.Actions.EditedActiveLayer.dispatch(this);

      // NOTE: Calling showPopup directly causes a bug where the popup content
      // is not initialized with Angular bindings so we use the action.
      this.leafletLayer.fire('layer:moved');

    }
    if (!map.dragging.enabled()) {
      map.dragging.enable();
    }

  },

  onLayerRemove: function () {
    this.hidePopup();
    this._removeEventListeners();
    this._removeStoreListeners();
  },

  _newUnregisterEventsRegistry: function () {
    return Object.create({
      _fns: [],
      add: function (fn) {
        if (this._fns.indexOf(fn) === -1) {
          this._fns.push(fn);
        }
      },
      reset: function () {
        this._fns = [];
      },
      run: function () {
        for (var i = this._fns.length - 1; i >= 0; i--) {
          this._fns[i]();
        }
        this._fns = [];
      }
    });
  }
};



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/edit/base/mixins/EventMixin.js